export const API_ENDPOINT = 'payments';
export const PLAN_ENDPOINT = `${API_ENDPOINT}/plans`;
export const CARD_DETAILS_ENDPOINT = `${API_ENDPOINT}/card-details`;
export const SUBSCRIPTION_ENDPOINT = `${API_ENDPOINT}/subscription`;
export const UPCOMING_INVOICE_ENDPOINT = `${API_ENDPOINT}/upcoming-invoice`;
export const COUPON_ENDPOINT = (couponId) => `coupon/${couponId}`;


// WEBPACK FOOTER //
// ./src/state/modules/payment/configurations/endpoints.js